import React from "react";
import { Tooltip } from "react-tippy";
import styled from "styled-components";
import * as icons from "./icons";

export const templates = {
  default: {
    height: "1.5em",
    width: "1.5em",
    fill: "#DDE2E3"
  },
  recipe: {
    height: "1.25em",
    width: "1.25em",
    fill: "#977535"
  },
  openBook: {
    height: "1.35em",
    width: "1.35em",
    fill: "#DDE2E3"
  },
  x: {
    fill: "#b3b3b3",
    height: "1.25em",
    width: "1.25em"
  },
  groceryRecipeX: {
    fill: "#ccc",
    height: "1.5em",
    width: "1.5em"
  },
  gl: {
    fill: "#ccc",
    height: "1.6875em",
    width: "1.6875em"
  },
  mp: {
    fill: "#D6D1C2",
    height: "1.25em",
    width: "1.25em"
  },
  arrow: {
    fill: "#D6D1C2",
    height: "2em",
    width: "2em"
  },
  dotsWhenOnWhite: {
    fill: "#b3b3b3",
    height: "1.125em",
    width: "1.125em"
  },
  ghostButton: {
    fill: "#999",
    height: "1.25em",
    width: "1.25em"
  },
  ghostButtonSmall: {
    fill: "#999",
    height: "1.15em",
    width: "1.15em"
  }
};

const Center = styled("div")`
  display: flex;
  align-items: center;
`;

export type PossibleIcons = keyof typeof icons;

export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "path"> & {
  tooltipText?: string;
  tooltipPosition?: "bottom" | "top" | "right" | "left";
  name: PossibleIcons;
  path?: React.ReactNode;
  template?: keyof typeof templates;
  style?: React.CSSProperties;
  svgRef?: any;
  arrow?: boolean;
  css?: string;
  tooltipTheme?: "light" | "dark";
};

export const Icon = ({
  tooltipText,
  tooltipPosition = "bottom",
  name,
  path,
  template = "default",
  style,
  svgRef,
  arrow = false,
  tooltipTheme = "light",
  ...other
}: IconProps) => {
  const iconComponent = (
    <Center>
      <svg
        data-testid={`icon-${name}`}
        viewBox={name === "openBook" ? "0 0 23 23" : "0 0 20 20"}
        {...templates[template]}
        {...other}
        ref={svgRef}
        style={{
          cursor: "pointer",
          ...style
        }}
      >
        {path ? path : <path d={icons[name]} />}
      </svg>
    </Center>
  );

  return tooltipText ? (
    <Tooltip
      arrow={arrow}
      title={tooltipText}
      position={tooltipPosition}
      theme={tooltipTheme}
      size="small"
    >
      {iconComponent}
    </Tooltip>
  ) : (
    iconComponent
  );
};

export default Icon;
